import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login';
import Home from '../views/Home.vue';
// import CardMake from '../views/CardMake.vue';
// import Card from '../views/Card.vue';
import Card1 from '@/views/Card1.vue';
import MyDrag from '@/views/drag-box.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: '登录',
    component: Login,
    hidden: true,
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  // {
  //   path: '/card-make',
  //   name: '制作答题卡',
  //   component: CardMake,
  // },
  // {
  //   path: '/card',
  //   name: '制作答题卡',
  //   component: Card,
  // },
  // {
  //   path: '/preview',
  //   name: '答题卡预览',
  //   component: Preview
  // },
  {
    path: '/card',
    name: '答题卡',
    component: Card1,
  },
  {
    path: '/drag',
    name: '拖拽',
    component: MyDrag,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
